import ApplicationController from "./application_controller"; 

export default class extends ApplicationController {
  static targets = ["result","nbDeResultat","resetIcon"]
  static values = { url: String }
 connect() {
    console.log("Search contact_controller JS en cours ...");
    super.connect();
  }
 
submit(event, page = null) {
  if (event) event.preventDefault()

  const form = this.element.closest("form") || document.querySelector("form")
  if (!form) return

  const url = this.urlValue || form.action
  const method = (form.method || "get").toUpperCase()

  this._setLoading(true)

  const formData = new FormData(form)
  
 
  if (page) {
    formData.append('page', page)
  }

  let fetchUrl = url
  let fetchOptions = {
    method,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Accept": "application/json"
    },
    credentials: "same-origin"
  }

  if (method === "GET") {
    const params = new URLSearchParams()
    formData.forEach((v, k) => params.append(k, v))
    fetchUrl = `${url}?${params.toString()}`
  } else {
    fetchOptions.body = formData
  }

  fetch(fetchUrl, fetchOptions)
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      return res.json()
    })
    .then((payload) => {
      this.resultTarget.innerHTML = payload.html 
      this.updateResultCount(payload.nb_de_resultat)
      
 
      // this.resultTarget.scrollIntoView({ behavior: 'smooth', block: 'start' })

      if (payload.flash?.message && page == null) {
        this._showFlash(payload.flash.type, payload.flash.message) 
      }
    })
    .catch((err) => {
      console.error("[search-contact] error:", err)
      this._showFlash("error", "Erreur lors de la recherche.")
    })
    .finally(() => {
      this._setLoading(false)
    })
}

 
changePage(event) {
  const link = event.target.closest("a")
  if (!link) return

  event.preventDefault()

  const href = link.getAttribute("href")
  const urlParams = new URLSearchParams(href.split('?')[1])
  const page = urlParams.get('page')

  if (page) {
    this.submit(null, page)
  }
}
 submit_old(event) {
  event.preventDefault()

  const form = this.element.closest("form") || document.querySelector("form")
  if (!form) {
    console.error("[search-contact] form not found")
    return
  }

  const url = this.urlValue || form.action
  const method = (form.method || "get").toUpperCase()

  this._setLoading(true)

  const formData = new FormData(form)

  let fetchUrl = url
  let fetchOptions = {
    method,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Accept": "application/json"
    },
    credentials: "same-origin"
  }

  if (method === "GET") {
    const params = new URLSearchParams()
    formData.forEach((v, k) => params.append(k, v))
    fetchUrl = `${url}?${params.toString()}`
  } else {
    fetchOptions.body = formData
  }

  fetch(fetchUrl, fetchOptions)
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      return res.json()
    })
    .then((payload) => {
    
      this.resultTarget.innerHTML = payload.html 
      this.updateResultCount(payload.nb_de_resultat)
       
      if (payload.flash?.message) {
        this._showFlash(payload.flash.type, payload.flash.message) 
      }
    })
    .catch((err) => {
      console.error("[search-contact] error:", err)
      this.resultTarget.innerHTML = `<div class="p-3">Erreur lors de la recherche.</div>`
      this._showFlash("error", "Erreur lors de la recherche.")
      this.nbDeResultatTarget.innerHTML = ""
    })
    .finally(() => {
      this._setLoading(false)
    })
}

 

reset(event) {
  event.preventDefault();
  
  // 1. Animation de rotation
  if (this.hasResetIconTarget) {
    this.resetIconTarget.classList.add('spinning');
    setTimeout(() => this.resetIconTarget.classList.remove('spinning'), 800);
  }

  // 2. Reset du formulaire
  const form = event.currentTarget.closest('form');
  form.reset();

  // 3. Réinitialisation du badge
  if (this.hasNbDeResultatTarget) {
    this.nbDeResultatTarget.innerHTML = "";
    this.nbDeResultatTarget.classList.remove('is-empty');
  }

  // 4. Injection du HTML "État Initial" dans la zone de résultat
  if (this.hasResultTarget) {
    this.resultTarget.innerHTML = `
      <div class="fl_no_record_div p-5">
        <div style="display:flex; flex-direction:column; align-items:center; justify-content:center; height:100%;">
          <div style="text-align:center; padding:20px; border:1px solid #ccc; border-radius:8px; background-color:#f9f9f9;">
            <i class="fas fa-search" style="font-size:48px; color:#ccc;"></i>
            <p style="font-size:14px;color:#666; margin-top:10px;">
              Veuillez saisir vos critères et lancer la recherche.
            </p>
          </div>
        </div>
      </div>
    `;
  }
}
 
 

  generateExport(event) {
    event.preventDefault();
    
    // On récupère les IDs stockés dans le bouton
    const ids = JSON.parse(event.currentTarget.dataset.searchContactIdsValue);
    
    if (!ids || ids.length === 0) {
      this._showFlash("error", "Aucun contact à exporter.");
      return;
    }

    this._setLoading(true);

    // On crée un formulaire temporaire pour forcer un POST
    const form = document.createElement("form");
    form.method = "POST";
    // On construit l'URL vers ton action Ruby
    form.action = `/${this.currentApp()}/search_contacts/generateExport`; 
    form.style.display = "none";

    // On ajoute le token d'authenticité Rails (CSRF)
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    if (csrfToken) {
      const csrfInput = document.createElement("input");
      csrfInput.type = "hidden";
      csrfInput.name = "authenticity_token";
      csrfInput.value = csrfToken;
      form.appendChild(csrfInput);
    }

    // On ajoute les IDs (on les envoie sous forme de tableau)
    ids.forEach(id => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "contact_ids[]";
      input.value = id;
      form.appendChild(input);
    });
 
    document.body.appendChild(form);
    form.submit(); 
    document.body.removeChild(form);
     
    setTimeout(() => this._setLoading(false), 2000);
  }
 
  currentApp() {
    return window.location.pathname.split('/')[1];
  }

  _setLoading(isLoading) {
    // disable le bouton + petite opacité
    if (isLoading){
      this.showLoader();
    }else{
      this.hideLoader();
    }
    const btn = this.element.querySelector(".fx-button")
    if (btn) btn.disabled = isLoading
    this.element.style.opacity = isLoading ? "0.7" : "1"
  }
  _showFlash(type, message) {
   
  const id = type === "success" ? "fx-conteneur-notice" : "fx-conteneur-error"
  const otherId = type === "success" ? "fx-conteneur-error" : "fx-conteneur-notice"

  document.getElementById(id)?.remove()
  document.getElementById(otherId)?.remove()

  const isSuccess = type === "success"

  const html = isSuccess
    ? `
      <div id="fx-conteneur-notice" class="fx-flash-top-right fx-flash-success fx-flash-message"
           data-controller="flash"
           data-flash-target="container"
           data-flash-timeout-value="5000"
           data-action="mouseenter->flash#mouseenter mouseleave->flash#mouseleave">
        <button class="fx-flash-close-button" data-action="flash#dismissManually">&times;</button>
        <div class="fx-inline-message">
          <span>${this._escapeHtml(message)}</span>
        </div>
        <div class="fx-progress-bar" data-flash-target="progressBar"></div>
      </div>
    `
    : `
      <div id="fx-conteneur-info" class="fx-flash-top-right fx-flash-info fx-flash-message"
           data-controller="flash"
           data-flash-target="container"
           data-flash-timeout-value="5000"
           data-action="mouseenter->flash#mouseenter mouseleave->flash#mouseleave">
        <button class="fx-flash-close-button" data-action="flash#dismissManually">&times;</button> 
        <div class="fx-d-inline-block">
          <div class="fx-inline-message">
           <span>${this._escapeHtml(message)}</span>
          </div>
        </div>
        <div class="fx-progress-bar" data-flash-target="progressBar"></div>
      </div>
    `

  document.body.insertAdjacentHTML(isSuccess ? "beforeend" : "afterbegin", html)

  const el = document.getElementById(id)
  if (!el) return

  window.setTimeout(() => {
    el.style.transition = "opacity 0.5s"
    el.style.opacity = "0"
    window.setTimeout(() => el.remove(), 500)
  }, 5000)
}

_escapeHtml(str) {
  return String(str)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;")
}
updateResultCount(count) {
  if (!this.hasNbDeResultatTarget) return

  if (count > 0) {
    this.nbDeResultatTarget.textContent = count
    this.nbDeResultatTarget.classList.remove("is-empty")
  } else {
    this.nbDeResultatTarget.textContent = "0"
    this.nbDeResultatTarget.classList.add("is-empty")
  }
}

}
